/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AssignRoleResponseData } from "./AssignRoleResponseData";
export const AssignRoleResponse = core.serialization.object({
    data: AssignRoleResponseData,
});
